import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { useAppContext } from '../libs/contextLib';

export default function AuthenticatedRoute({ children, scope, ...rest }) {
  const { pathname, search } = useLocation();
  const { user } = useAppContext();

  if (!user.isAuthenticated) {
    localStorage.setItem('lwd-userRedirect', `${pathname}${search}`);
    return (
      <Route {...rest}>
        <Redirect to={`/login?redirect=${encodeURIComponent(`${pathname}${search}`)}`} />
      </Route>
    );
  }

  // `scope` is the route's list of who may open it (the same list the sidebar uses).
  // Signed-in users with none of them go back to the dashboard; the page never renders.
  if (Array.isArray(scope) && !(user.scope || []).some((s) => scope.includes(s))) {
    return (
      <Route {...rest}>
        <Redirect to="/" />
      </Route>
    );
  }

  return <Route {...rest}>{children}</Route>;
}
